/**
 * Posts an error to sentry, if possible.
 *
 * @param {*} error - Message
 */
export const handleSentryError = (error) => {
  if (window.Raven && window.Raven.captureMessage) {
    window.Raven.captureException(error);
  } else {
    console.error(error);
  }
};



// WEBPACK FOOTER //
// ./src/modules/handle-error.js